module.exports = __webpack_public_path__ + "img/workbench-white.ebb72be6.png";